import React from 'react';
import { PageTitle } from '@gsa/afp-component-library';
import { useUpiidDetails } from '../../components/upiid-details/upiid-details-provider';
import UpiidDetailsFormContext from '../../components/upiid-details/upiid-details-form-context';
import SolicitationStepper from '../../components/solicitation-stepper';
import SolicitationNotification from '../../utils/solicitation-notification';
import '../../components/upiid-details/solicitation-upiid-details.scss';
import SolicitationStatusBadge from '../../components/solicitation-status-badge';
import EditSolicitationForm from './edit-solicitation-form';
import InactiveSIAlert from '../../components/solicitation-alert/inactive-si-alert';

const EditSolicitation = () => {
  const { solicitation, bidType } = useUpiidDetails();

  return (
    <div className="grid-col solicitation-upiid-details">
      <SolicitationNotification isModal={false} />
      <InactiveSIAlert
        solicitationPrograms={solicitation.programs}
        contractYear={solicitation.contractYear}
      />
      <div className="grid-row flex-row">
        <PageTitle
          title={`Edit Solicitation - ${solicitation.solicitationNumber}`}
        />
        <div className="statusBadgeContainer margin-left-1">
          <SolicitationStatusBadge status={solicitation.solicitationStatus} />
        </div>
      </div>
      <SolicitationStepper
        currentStep={1}
        solicitation={solicitation}
        currentBidType={bidType}
      />
      <UpiidDetailsFormContext solicitation={solicitation}>
        <EditSolicitationForm />
      </UpiidDetailsFormContext>
    </div>
  );
};

export default EditSolicitation;
